import React, {useCallback} from 'react';
import {Icon, PriorityIcon, Text, Title} from '@priority-software/priority-style-react';
import {isRTL} from '../../../../../Localization';
import {Breadcrumb, BreadCrumbsList} from '../../../types';
import styles from './styles.module.scss';
import {createDataTestId} from '../../../../../utils/dataTestId';

type Props = {
    data: BreadCrumbsList;
    onItemClick: (level: number, session: string) => void;
};

export const Breadcrumbs = (props: Props) => {
    const {data, onItemClick} = props;

    return (
        <div className={styles.component}>
            <div className={styles.breadcrumbs}>
                {data?.map((item, index) => {
                    return (
                        <BreadCrumbsItem
                            key={item.ename}
                            isLast={index === data.length - 1}
                            item={item}
                            onItemClick={onItemClick}
                        />
                    );
                })}
            </div>
        </div>
    );
};

type ItemProps = {
    isLast: boolean;
    item: Breadcrumb;
    onItemClick: (level: number, session: string) => void;
};

export const BreadCrumbsItem = ({isLast, item, onItemClick}: ItemProps) => {
    const rtl = isRTL();
    const {level, session, ename, title} = item;

    const onClick = useCallback(async () => {
        await onItemClick(level, session);
    }, [onItemClick, level, session]);

    if (isLast) {
        return (
            <div className={styles.item} key={ename}>
                <Title
                    {...createDataTestId('breadcrumbs-title', true)}
                    skin="h3"
                    textColor="primary-500"
                    text={title}
                    style={{lineHeight: 1}}
                    fontWeight="normal"
                />
            </div>
        );
    }

    return (
        <div
            className={styles.item}
            key={item.ename}
            {...createDataTestId('breadcrumbs-item', false)}
        >
            <Text
                tag="div"
                skin="breadcrumb"
                onClick={onClick}
                componentClasses={styles.breadcrumbLink}
            >
                {item.title}
            </Text>

            <Icon
                icon={rtl ? PriorityIcon.arrowLeft : PriorityIcon.arrowRight}
                iconColor="secondary-400"
                componentClasses={styles.separator}
            />
        </div>
    );
};
